import React, { useState, useEffect } from "react";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";

import {
  MutationWithArrayInput,
  generateAndExecuteMutation,
  graphqlQuery,
} from "../../../data/Axios/DynamicService";

import {
  HRService,
  caseManagementUrl,
  setupManagementUrl,
} from "../../../config";

import DynamicForm from "../../../data/Axios/DynamicForm";
import { allCasesView } from "../../../data/Axios/queries";
import {
  allDisbursementType,
  imprestApplications,
} from "../../../data/Queries/HRmanagement/leavemanagement";
import { staffClaimsFields } from "../../../data/DynamicTable/FormsFields/LeaveApplicationForms";

const base_url = HRService.uri;

const SurrenderLineForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const companyId = parseInt(decodedToken.CompanyId);
  const surrenderData = JSON.parse(localStorage.getItem("SurrenderId"));
  const initialValues = {};

  const fields = [
    {
      name: "amount",
      label: "Amount",
      type: "number",
      required: true,
      gridColumn: "span 2",
    },
    {
      name: "description",
      label: "Description",
      type: "text",
      required: true,
      gridColumn: "span 2",
    },
  ];

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const { amount, description } = values;
      const mutationData = {
        amount,
        description,
        applicationId: surrenderData ? surrenderData.applicationId : null,
        surrenderId: surrenderData ? surrenderData.id : null,
      };

      const response = await generateAndExecuteMutation(
        "addRemoveImprestSurrenderLines",
        mutationData,
        "lines",
        base_url
      );

      if (Object.values(response)[0] != null) {
        props.onClose();
        props.refetchData();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Staff surrender line created successfully.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }

    setSubmitting(false);
  };

  return (
    <DynamicForm
      initialValues={initialValues}
      fields={fields}
      onSubmit={handleSubmit}
      title={"Create Staff Claim line Application"}
      subtitle={"Fill out the form below to create a staff claim line."}
    />
  );
};

export default SurrenderLineForm;
